import { createAsyncThunk } from '@reduxjs/toolkit';
import ArtworkResource from 'api/service/ArtworkResource';
import FilesResource from 'api/service/FilesResource';
import { blobDownload } from 'utils/download';

export const getArtworkFile = createAsyncThunk('artworks/getArtworkFile', async (initialData, { rejectWithValue }) => {
  const filesResource = new FilesResource();
  const { id } = initialData;
  const { data, status } = await filesResource.get(id);
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Artwork File not found.');
});

export const getEditorUrl = createAsyncThunk('artworks/getEditorUrl', async (initialData, { rejectWithValue }) => {
  const artworkResource = new ArtworkResource();
  const { status, data } = await artworkResource.editorUrl();
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Error loading editor url');
});

export const loadArtwork = createAsyncThunk('artworks/loadArtwork', async (initialData, { rejectWithValue }) => {
  const artworkResource = new ArtworkResource();
  const { id } = initialData;
  const { status, data } = await artworkResource.load(id);
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Artwork file not found');
});

export const downloadArtworkPdf = createAsyncThunk('marketplace/downloadArtworkPdf', async (initialData) => {
  const { id, name } = initialData;
  const artworkResource = new ArtworkResource();
  const { data, status } = await artworkResource.downloadPdf(id);
  if (status === 200) {
    blobDownload(data, name);
    return id;
  }
});
